module.exports = __webpack_public_path__ + "img/ve.d358f342.svg";